import { CreateAnimation, IonCol, IonImg, IonRow, IonText } from "@ionic/react";
import { Pole_t } from "../../types/pole";
import { ItemsTechno } from "../../variables/welcomeInterface";
import Pole from "./Pole";

interface Props {
  displayPole: number;
  handleClick: (item: ItemsTechno, index: number) => void;
  item: ItemsTechno;
  index: number;
}

const ItemTechno: React.FC<Props> = ({
  displayPole,
  handleClick,
  item,
  index,
}) => {
  const pole = () => {
    const poles: Pole_t[] = [];

    if (item.subItems) poles.push(...item.subItems);
    else return;

    return (
      <IonRow className="fullWidth ion-text-center pole ion-justify-content-center">
        {poles.map((p, i, arr) => {
          return (
            <Pole
              arrayLength={arr.length}
              href={item.href ?? ""}
              pole={p}
              size={Number.parseInt(item.size ?? "12") <= 6 ? arr.length : 1}
              key={i}
            />
          );
        })}
      </IonRow>
    );
  };

  return (
    <>
      <IonCol size={item.size ?? "12"} className="no-padding no-margin">
        <IonRow>
          <IonCol
            className="part border-radius"
            style={{
              minHeight: "calc( " + (item.height ?? "1") + " * 200px )",
            }}
            onClick={() => handleClick(item, index)}
          >
            <IonRow className="fullHeight border-radius">
              <IonCol
                className="no-margin no-padding border-radius-bottom"
                style={{ overflow: "hidden" }}
              >
                <IonRow
                  className={
                    "border-radius-top ion-align-items-center " +
                    (item.picture_url ? "" : "fullHeight")
                  }
                  style={{ backgroundColor: item.bgColor }}
                >
                  {item.icon && (
                    <IonCol
                      size="3"
                      className="fullHeight ion-align-items-center flex"
                    >
                      <IonImg
                        className="icon"
                        src={item.icon}
                        color={item.iconColor}
                      />
                    </IonCol>
                  )}
                  <IonCol size={item.icon ? "9" : "12"}>
                    <IonText
                      color="black"
                      style={{
                        overflow: "hidden",
                      }}
                    >
                      <h3
                        className="no-margin no-padding text-ellipsis"
                        style={
                          item.icon
                            ? {
                                fontSize: "min(4vw,20px)",
                              }
                            : {
                                paddingLeft: "20px",
                              }
                        }
                      >
                        {item.title}
                      </h3>
                    </IonText>
                  </IonCol>
                </IonRow>
                {item.picture_url && (
                  <IonRow
                    style={{
                      height: "100%",
                      backgroundSize: "cover",
                      backgroundImage: 'url("' + item.picture_url + '")',
                      backgroundPosition: "center center",
                    }}
                  ></IonRow>
                )}
              </IonCol>
            </IonRow>
          </IonCol>
        </IonRow>
        {displayPole === index && (
          <CreateAnimation
            duration={300}
            iterations={1}
            easing="ease-out"
            fromTo={[
              {
                property: "transform",
                fromValue: "translateY(-10px)",
                toValue: "translateY(0px)",
              },
              { property: "opacity", fromValue: "0", toValue: "1" },
            ]}
            play={true}
          >
            {pole()}
          </CreateAnimation>
        )}
      </IonCol>
    </>
  );
};

export default ItemTechno;
